var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-divider',{staticClass:"mt-3 mb-2"}),_vm._v(" "),_c('v-alert',{attrs:{"value":_vm.alertMsg,"type":_vm.alertType,"transition":"scale-transition"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertMsg)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b04082","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/bits/Alerts.vue
// module id = null
// module chunks = 